import { render, staticRenderFns } from "./arrow-left.vue?vue&type=template&id=67ec1e8f"
import script from "./arrow-left.vue?vue&type=script&lang=js"
export * from "./arrow-left.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports